import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBinoculars } from '@fortawesome/free-solid-svg-icons';
import '../styles/BinocularsLoader.css';

const BinocularsLoader = ({ style }) => {
  return (
    <div className={`binoculars-loader ${style ? 'dark-mode' : ''}`}>
      <div className="binoculars-container">
        <div className="binoculars-icon">
          <FontAwesomeIcon icon={faBinoculars} />
        </div>
        <div className="searching-text">
          <span>جاري البحث</span>
          <div className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BinocularsLoader; 